import { render } from "./Inventory_process_number_input.vue?vue&type=template&id=4e4f87b8&scoped=true"
import script from "./Inventory_process_number_input.vue?vue&type=script&lang=js"
export * from "./Inventory_process_number_input.vue?vue&type=script&lang=js"

import "./Inventory_process_number_input.vue?vue&type=style&index=0&id=4e4f87b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4f87b8"]])

export default __exports__